export default __webpack_public_path__ + "static/media/cs_icon_08_on.dcc9edce.png";